/* eslint-disable no-extend-native */
import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import ReportsTable from './ReportsTable'
import { getReports, getUsers } from '../../utils/api'
import { ColoredLine } from '../elements/ColoredLine'
import makeAnimated from 'react-select/animated';
import { checkUserToken, CheckUserToken } from '../../utils/checkUser'

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faShareSquare } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faShareSquare)
const animatedComponents = makeAnimated();
const Reports = () => {

    const [reports, setReports] = useState([]);
    const [users, setUsers] = useState([]);

    const [reportsVisible, setReportsVisible] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => { 
        getUsers(setUsers);
        getReports(setReports);
        checkUserToken();
    }, []);


    //Filter Level 1
    useEffect(() => {
        setReportsVisible(
            reports.filter((r) => {
            return(
                r.name.toLowerCase().includes(searchText.toLowerCase().trim())
                )
            })
        )          
    }, [searchText, reports]);

    return (
        <Container className="section-container" fluid>  
            <Row className='row-header'>
                <h2 className="page-header">New Report</h2>    
            </Row>          
            <ColoredLine color="#DEDEDE" />
                <Row>
                    <h5 className="filter-headers">Search</h5>
                    <Col lg={5} sm={6} xs={12}>
                        <Form.Control
                            onChange={(e) => setSearchText(e.target.value)}
                            className="mb-3"
                            type="text"
                            placeholder="Search name or description..."
                        />
                    </Col>
                </Row>
                <ReportsTable 
                    reports={reportsVisible} 
                    users={users} 
                    />           

        </Container>
    )
}

export default Reports